import type { UI } from '@/v2/types';

const isNotNull = (val: string | null): val is string => !!val;

const getUniquePromosCodes = (flightOptions?: UI.FlightOptions) => {
  if (!flightOptions) {
    return undefined;
  }
  const { inbound = [], outbound = [] } = flightOptions;
  const allJourneys = [...inbound, ...outbound];
  const promoCodes = allJourneys.flatMap((journey) => {
    return journey.flightSegments.map((segment) => segment.promotionCode);
  });
  return new Set(promoCodes.filter(isNotNull));
};

export default getUniquePromosCodes;
